import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const SendReminders = () => {
  const messageDefault = "Send Reminders";
  const messageProcessing = "Sending emails...";
  const button = document.querySelector("#sendReminders");
  if (button) {
    button.addEventListener("click", (ev) => {
      ev.preventDefault();
      const data = new FormData();
      data.append("action", "send_reminders");
      ev.target.textContent = messageProcessing;
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) { 
            //console.log("Data received from server:", result); 
          }
          delay(1000).then(() => {
            ev.target.textContent = messageDefault;
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: null,
            });
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          ev.target.textContent = messageDefault;
          createToast({
            type: "error",
            message: "System Error",
            duration: 1000,
          });
        });
    });
  }
};

export { SendReminders };
